import Axios,{ HttpResponse } from '../http'

export type ProductParams = {
    auditStatus: number
    pageIndex: number
    pageSize: number
}

export type productCategory = {
    value : string,
    label : string,
    children : productCategory[]
}

export type productStateNumber = {
    unauditedNumber : number,
    approvedNumber : number,
    rejectedNumber : number,
}

export type productListInfo = {
    productId : number,
    productName : string,
    marketTypeName : string,
    imagePath : string,
    isRecommend : string,
    applicationType : string,
    auditStatusText: string,
    updateDate: Date
}

export type productPaged = {
    list : productListInfo[],
    records : number
}


export type matching = {
    typicClient : string,
    typicModels : string,
    typicOEM : string
  }

export type productInfo = {
    productId : number,
    productName : string,
    category : string[], // 分类
    makeMethods : string[], // 制造工艺
    suitSystem : string[], // 适用系统
    othersystem : string, // 其他
    applicationType :  string[], // 适用车型
    mathcing: matching[], // 配套情况
    designedCapacify : string, // 设计产能
    availableCapacify : string, // 剩余产能
    annualSales : string, // 年销售量
    annualTurnover : string, // 年销售额
    saleRatio :  string, // 销售占比
    productDesc :  string, // 产品描述
    advantageDesc :  string, // 独特优势
    applyScene :  string, // 应用场景
    prospect :  string, // 未来前景
    imagePath:  string // 产品图片
    isPublicly: number // 是否公开显示
}

export class ProductService {

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static async stateNumber() : Promise<HttpResponse<productStateNumber>> {
        return Axios('/api/product/stateNumber', {
            method: 'get',
            responseType: 'json',
            params: {
            },
        })
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static async products(params: ProductParams) : Promise<HttpResponse<productPaged>> {
        return Axios('/api/product', {
            method: 'get',
            responseType: 'json',
            params: {
                ...params
            },
        })
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static async categories() : Promise<HttpResponse<productCategory[]>>{
        return Axios('/api/product/category', {
            method: 'get',
            responseType: 'json',
            params: {

            },
        })
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static async productInfo(id : number) : Promise<HttpResponse<productInfo>>{
        return Axios('/api/product/info?id=' + id , {
            method: 'get',
            responseType: 'json',
            params: {

            },
        })
    }

    static async create(productInfo : productInfo, fileId : number) : Promise<HttpResponse<number>> {
        return Axios('/api/product/create', {
            method: 'post',
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            params: {
                fileId : fileId
            },
            data : JSON.stringify(
                {
                    productId : productInfo.productId,
                    productName : productInfo.productName,
                    category : productInfo.category,
                    makeMethods : productInfo.makeMethods,
                    suitSystem : productInfo.suitSystem,
                    othersystem : productInfo.othersystem,
                    applicationType : productInfo.applicationType,
                    mathcing : productInfo.mathcing,
                    designedCapacify : productInfo.designedCapacify,
                    availableCapacify : productInfo.availableCapacify,
                    annualSales : productInfo.annualSales,
                    annualTurnover : productInfo.annualTurnover,
                    saleRatio : productInfo.saleRatio,
                    productDesc : productInfo.productDesc,
                    advantageDesc : productInfo.advantageDesc,
                    applyScene : productInfo.applyScene,
                    prospect : productInfo.prospect,
                    imagePath : productInfo.imagePath,
                    isPublicly: productInfo.isPublicly
                }
            )
        })
    }
    
    static async edit(productInfo : productInfo, fileId : number) : Promise<HttpResponse<number>> {
        return Axios('/api/product/edit', {
            method: 'post',
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            params: {
                fileId : fileId
            },
            data : JSON.stringify(
                {
                    productId : productInfo.productId,
                    productName : productInfo.productName,
                    category : productInfo.category,
                    makeMethods : productInfo.makeMethods,
                    suitSystem : productInfo.suitSystem,
                    othersystem : productInfo.othersystem,
                    applicationType : productInfo.applicationType,
                    mathcing : productInfo.mathcing,
                    designedCapacify : productInfo.designedCapacify,
                    availableCapacify : productInfo.availableCapacify,
                    annualSales : productInfo.annualSales,
                    annualTurnover : productInfo.annualTurnover,
                    saleRatio : productInfo.saleRatio,
                    productDesc : productInfo.productDesc,
                    advantageDesc : productInfo.advantageDesc,
                    applyScene : productInfo.applyScene,
                    prospect : productInfo.prospect,
                    imagePath : productInfo.imagePath,
                    isPublicly: productInfo.isPublicly
                }
            )
        })
    }
    
    static async delete(productId : number) : Promise<HttpResponse<number>> {
        return Axios('/api/product/delete', {
            method: 'post',
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
              },
              params: {
                productId : productId
            },
        })
    }

}